/* 47X · EMPAQUE PREMIUM DSX47 · upsell de carrito · ES5
   ─────────────────────────────────────────────────────────────────────────
   No toca el carrito del tema. Se cuelga de su contrato público:
     · escucha  window 'cart47:refresh'  → el drawer acaba de repintarse
     · dispara  window 'cart47:refresh'  → drawer, contador y subtotal se
       actualizan solos tras agregar o quitar el empaque
   Por eso la tarjeta se monta FUERA de [data-cart47-body], que el drawer
   borra y reescribe en cada render.

   Reglas duras que se cumplen aquí:
     · una sola unidad del empaque, pase lo que pase
     · sin Mystery Box elegible en la bolsa, el empaque se retira solo
     · dos Mystery Box siguen llevando un solo empaque
     · clics repetidos no duplican: hay candado mientras vuela la petición
     · si el cliente lo quita, no se lo volvemos a poner en esa sesión
*/
(function () {
  'use strict';

  var cfg = null;
  var ocupado = false;
  var vistoYa = false;
  var LLAVE_FUERA = 'emp47:fuera';

  function leeCfg() {
    if (cfg) return cfg;
    try {
      var n = document.querySelector('[data-emp47-cfg]');
      cfg = n ? JSON.parse(n.textContent) : null;
    } catch (e) { cfg = null; }
    return cfg;
  }

  function seSalio() {
    try { return sessionStorage.getItem(LLAVE_FUERA) === '1'; } catch (e) { return false; }
  }
  function marcaSalida(v) {
    try { v ? sessionStorage.setItem(LLAVE_FUERA, '1') : sessionStorage.removeItem(LLAVE_FUERA); } catch (e) {}
  }

  /* dataLayer de GTM · si no existe se crea, es el contrato estándar */
  function evento(nombre, extra) {
    try {
      var d = { item_name: 'EMPAQUE PREMIUM DSX47' };
      if (cfg) { d.item_id = cfg.empaque; d.value = cfg.precio / 100; d.currency = cfg.moneda || 'MXN'; }
      if (extra) { for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) d[k] = extra[k]; } }
      if (window.Ev47) window.Ev47.pub(nombre, d);
    } catch (e) {}
  }

  /* Respeta el formato de dinero de la tienda ("$ 1,499", con espacio).
     Antes lo escribía a mano y la tarjeta decía $1,719 mientras el resto de
     la página decía $ 1,719. Detalle chico que se lee como descuido. */
  function dinero(cent, forzarDec) {
    var n = (Number(cent) || 0) / 100;
    var f = (cfg && cfg.formato) || '${{amount}}';
    var conDec = forzarDec || (n % 1 !== 0);
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (todo, k) {
      var coma = k.indexOf('comma_separator') !== -1;
      /* como money_without_trailing_zeros: los .00 no se pintan */
      var s = n.toFixed(conDec ? 2 : 0);
      var p = s.split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, coma ? '.' : ',');
      return p.length > 1 ? p[0] + (coma ? ',' : '.') + p[1] : p[0];
    });
  }

  /* ── lectura del carrito ────────────────────────────────────────────── */
  function analiza(cart) {
    var c = leeCfg();
    var r = { caja: null, empaque: null, unidades: 0, subtotal: 0 };
    if (!c || !cart || !cart.items) return r;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (String(it.variant_id) === String(c.empaque)) {
        r.empaque = it; r.unidades = it.quantity || 0;
      } else if (c.elegibles.indexOf(String(it.product_id)) !== -1) {
        if (!r.caja) r.caja = it;
      }
    }
    r.subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    return r;
  }

  function pideCarrito() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* ── mutaciones · siempre una unidad ────────────────────────────────── */
  function agrega() {
    var c = leeCfg();
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(c.empaque), quantity: 1 }] })
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function ajusta(key, cant) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: cant })
    }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  /* ── la tarjeta ─────────────────────────────────────────────────────── */
  function construye() {
    var c = leeCfg();
    var d = document.createElement('div');
    d.className = 'emp47';
    d.setAttribute('data-emp47', '');
    d.hidden = true;
    d.innerHTML =
      '<p class="emp47__kicker">' + c.titulo + '</p>' +
      '<button class="emp47__row" type="button" data-emp47-toggle role="switch" aria-checked="false">' +
        '<span class="emp47__box" aria-hidden="true">' +
          '<svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3.2 3.2L13 5" stroke="' + c.acento + '" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<span class="emp47__mid">' +
          '<span class="emp47__name">' + c.nombre + ' <span class="emp47__mas">+' + c.precio_txt + '</span></span>' +
          '<span class="emp47__ben">' + c.beneficios + '</span>' +
        '</span>' +
      '</button>' +
      '<div class="emp47__cuenta" data-emp47-cuenta hidden>' +
        '<div class="emp47__ln"><span data-emp47-caja-t></span><b data-emp47-caja-p></b></div>' +
        '<div class="emp47__ln"><span>' + c.nombre + '</span><b class="emp47__mas">+' + c.precio_txt + '</b></div>' +
        '<div class="emp47__ln emp47__ln--tot"><span>Total</span><b data-emp47-total></b></div>' +
      '</div>' +
      '<p class="emp47__nota" data-emp47-nota hidden>' + c.nota + '</p>';
    return d;
  }

  /* Fuera del cuerpo que el drawer reescribe: ni la hilera de ofertas ni el
     pie se borran en cada render, así que la tarjeta sobrevive.

     Se monta PRIMERO en la hilera de ofertas de la bolsa, no en el pie: ahí
     compite de tú a tú con el resto de ofertas y deja de ser un bloque suelto
     encima del total. Si esa hilera no existiera —otra plantilla, otra
     versión—, cae al pie como siempre. */
  function monta() {
    var puntos = [];
    var hilera = document.querySelector('.cart47__panel [data-cart47-packup]');
    if (hilera) {
      puntos.push({ nodo: hilera, modo: 'antes-dentro' });
      /* la hilera nace oculta: con el empaque dentro ya tiene qué mostrar */
      hilera.hidden = false;
    }
    var pie = hilera ? null : document.querySelector('.cart47__panel .cart47__foot');
    if (pie) puntos.push({ nodo: pie, modo: 'antes-dentro' });
    var pago = document.querySelector('#checkout');
    if (pago) {
      var caja = pago.closest('.cart__ctas, .cart__blocks, form') || pago.parentNode;
      if (caja) puntos.push({ nodo: caja, modo: 'antes' });
    }
    for (var i = 0; i < puntos.length; i++) {
      var p = puntos[i];
      var ancla = p.modo === 'antes-dentro' ? p.nodo : p.nodo.parentNode;
      if (!ancla) continue;
      if (p.modo === 'antes-dentro') {
        if (p.nodo.querySelector('[data-emp47]')) continue;
        p.nodo.insertBefore(construye(), p.nodo.firstChild);
      } else {
        if (ancla.querySelector('[data-emp47]')) continue;
        ancla.insertBefore(construye(), p.nodo);
      }
    }
    return document.querySelectorAll('[data-emp47]');
  }

  /* ── pintado ────────────────────────────────────────────────────────── */
  function pinta(cart) {
    var c = leeCfg();
    if (!c) return;
    var e = analiza(cart);
    var tarjetas = monta();
    var puesto = !!e.empaque;
    var visible = !!e.caja;

    for (var i = 0; i < tarjetas.length; i++) {
      var t = tarjetas[i];
      t.hidden = !visible;
      t.classList.toggle('is-on', puesto);
      var btn = t.querySelector('[data-emp47-toggle]');
      if (btn) btn.setAttribute('aria-checked', puesto ? 'true' : 'false');

      var cuenta = t.querySelector('[data-emp47-cuenta]');
      var nota = t.querySelector('[data-emp47-nota]');
      if (cuenta) cuenta.hidden = !puesto;
      if (nota) nota.hidden = puesto;

      if (puesto && e.caja) {
        var ct = t.querySelector('[data-emp47-caja-t]');
        var cp = t.querySelector('[data-emp47-caja-p]');
        var tt = t.querySelector('[data-emp47-total]');
        if (ct) ct.textContent = e.caja.product_title || e.caja.title;
        if (cp) cp.textContent = dinero(e.caja.final_line_price != null ? e.caja.final_line_price : e.caja.line_price);
        if (tt) tt.textContent = dinero(e.subtotal);
      }
    }

    if (visible && !vistoYa) { vistoYa = true; evento('premium_packaging_view'); }
    return e;
  }

  /* ── conciliación · deja el carrito coherente sin que nadie toque nada ─ */
  function concilia(cart) {
    var c = leeCfg();
    var e = analiza(cart);

    /* Se fue la Mystery Box: el empaque no tiene por qué seguir cobrándose */
    if (!e.caja && e.empaque) {
      return ajusta(e.empaque.key, 0).then(function () { return 'cambio'; });
    }
    /* Más de uno: nunca. Da igual cómo haya llegado ahí */
    if (e.empaque && e.unidades > 1) {
      return ajusta(e.empaque.key, 1).then(function () { return 'cambio'; });
    }
    /* Preseleccionado, salvo que el cliente ya lo haya quitado a mano */
    if (c.pre && e.caja && !e.empaque && !seSalio()) {
      return agrega().then(function (r) {
        if (r) evento('premium_packaging_added', { motivo: 'preseleccion' });
        return 'cambio';
      });
    }
    return Promise.resolve('igual');
  }

  function ciclo() {
    if (ocupado) return Promise.resolve();
    ocupado = true;
    return pideCarrito().then(function (cart) {
      if (!cart) { ocupado = false; return; }
      return concilia(cart).then(function (res) {
        if (res === 'cambio') {
          return pideCarrito().then(function (c2) {
            ocupado = false;
            pinta(c2);
            /* el drawer, el contador y el subtotal se enteran por su propio canal */
            try { window.dispatchEvent(new CustomEvent('cart47:refresh')); } catch (e) {}
          });
        }
        ocupado = false;
        pinta(cart);
      });
    }).catch(function () { ocupado = false; });
  }

  /* ── el clic ────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-emp47-toggle]') : null;
    if (!btn) return;
    ev.preventDefault();
    var tarjeta = btn.closest('[data-emp47]');
    if (!tarjeta || ocupado) return;

    var quitando = tarjeta.classList.contains('is-on');
    ocupado = true;
    var todas = document.querySelectorAll('[data-emp47]');
    for (var i = 0; i < todas.length; i++) todas[i].classList.add('is-busy');

    pideCarrito().then(function (cart) {
      var e = analiza(cart);
      if (quitando) {
        if (!e.empaque) return null;
        marcaSalida(true);
        return ajusta(e.empaque.key, 0).then(function (r) { evento('premium_packaging_removed'); return r; });
      }
      marcaSalida(false);
      if (e.empaque) return cart;                 /* ya estaba: no se duplica */
      return agrega().then(function (r) { if (r) evento('premium_packaging_added', { motivo: 'clic' }); return r; });
    }).then(function () {
      return pideCarrito();
    }).then(function (c2) {
      ocupado = false;
      var t2 = document.querySelectorAll('[data-emp47]');
      for (var j = 0; j < t2.length; j++) t2[j].classList.remove('is-busy');
      pinta(c2);
      try { window.dispatchEvent(new CustomEvent('cart47:refresh')); } catch (e) {}
    }).catch(function () {
      ocupado = false;
      var t3 = document.querySelectorAll('[data-emp47]');
      for (var k = 0; k < t3.length; k++) t3[k].classList.remove('is-busy');
    });
  }, false);

  /* Al pagar, avisamos si el empaque va dentro */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest ? ev.target.closest('#checkout, a[href="/checkout"], [name="checkout"]') : null;
    if (!a) return;
    var puesto = document.querySelector('[data-emp47].is-on');
    if (puesto) evento('checkout_with_premium_pack');
  }, true);

  /* ── arranque ───────────────────────────────────────────────────────── */
  function arranca() {
    if (!leeCfg()) return;
    ciclo();
    /* cada vez que el drawer se repinta, la tarjeta se vuelve a colgar */
    window.addEventListener('cart47:refresh', function () { setTimeout(ciclo, 60); });
    window.addEventListener('cart47:open', function () { setTimeout(ciclo, 60); });
    document.addEventListener('cart47:added', function () { setTimeout(ciclo, 60); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }
})();
